import { ICompanyClientInfo } from 'interfaces/company/client.company.interface';
import clientManual from './files/lb-client-manual.pdf';

export const companyClientInfo: ICompanyClientInfo = {
  manual: { filePath: clientManual, fileName: 'Manual do cliente.pdf' },
};
